import {
  CommerciaSignUpInput,
  CommerciaSignUpInputError,
  ResetCommercialPasswordInput,
  ResetCommercialPasswordInputError,
} from "modules/user_management/commercial_user/user/state/actionType";

export const ValidateForm = (
  data: CommerciaSignUpInput
): CommerciaSignUpInputError => {
  const errors: CommerciaSignUpInputError = {};

  if (!data.name.trim()) {
    errors.name = "Name is required";
  }

  if (!data.email.trim()) {
    errors.email = "Email is required";
  } else if (!/^\S+@\S+\.\S+$/.test(data.email)) {
    errors.email = "Invalid email format";
  }

  if (!data.mobile_no.trim()) {
    errors.mobile_no = "Mobile number is required";
  }

  if (!data.gender.trim()) {
    errors.gender = "Gender is required";
  }

  if (!data.password) {
    errors.password = "Password is required";
  }

  if (!data.confirm_password) {
    errors.confirm_password = "Confirm Password is required";
  } else if (data.password !== data.confirm_password) {
    errors.confirm_password = "Passwords do not match";
  }

  return errors;
};
export default ValidateForm;

export const ValidateRsetPassowrdForm = (
  data: ResetCommercialPasswordInput
): ResetCommercialPasswordInputError => {
  const errors: ResetCommercialPasswordInputError = {};
  if (!data.password) {
    errors.password = "Password is required";
  } else if (data.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  if (!data.confirm_password) {
    errors.confirm_password = "Confirm Password is required";
  } else if (data.password !== data.confirm_password) {
    errors.confirm_password = "Passwords do not match";
  }

  return errors;
};